import { render } from "./SettingsRow.vue?vue&type=template&id=7b35547a&scoped=true"
import script from "./SettingsRow.vue?vue&type=script&lang=js"
export * from "./SettingsRow.vue?vue&type=script&lang=js"

import "./SettingsRow.vue?vue&type=style&index=0&id=7b35547a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b35547a"]])

export default __exports__